  (function () {
    'use strict';

    function setToggleLabel(toggle, text) {
      if (!toggle) return;
      text = (text || '').trim();
      var labelEl = toggle.querySelector('.ps-dropdown-label');
      if (labelEl) {
        labelEl.textContent = text;
        return;
      }
      var svg = toggle.querySelector('svg');
      var span = document.createElement('span');
      span.className = 'ps-dropdown-label';
      span.textContent = text + ' ';
      if (svg) {
        toggle.insertBefore(span, svg);
      } else {
        toggle.textContent = text;
      }
    }

    var sections = document.querySelectorAll('.ps-section');
    if (!sections || sections.length === 0) return;

    sections.forEach(function (section) {
      var tabs = Array.prototype.slice.call(section.querySelectorAll('.ps-tab'));
      var panels = Array.prototype.slice.call(section.querySelectorAll('.ps-tab-panel'));
      var dropdown = section.querySelector('[data-ps-dropdown]');
      var selectList = dropdown ? dropdown.querySelector('.ps-dropdown-list') : null;
      var toggle = dropdown ? dropdown.querySelector('.ps-dropdown-toggle') : null;
      var options = selectList ? Array.prototype.slice.call(selectList.querySelectorAll('.ps-dropdown-option')) : [];

      function updatePanelState(target) {
        if (!target) return;
        tabs.forEach(function (t) {
          var isActive = t.getAttribute('data-tab') === target;
          t.classList.toggle('is-active', isActive);
          t.setAttribute('aria-selected', isActive ? 'true' : 'false');
          t.setAttribute('tabindex', isActive ? '0' : '-1');
        });
        panels.forEach(function (p) {
          var match = p.getAttribute('data-panel') === target;
          p.classList.toggle('is-active', match);
          if (match) {
            p.removeAttribute('hidden');
            p.setAttribute('aria-hidden', 'false');
          } else {
            p.setAttribute('hidden', '');
            p.setAttribute('aria-hidden', 'true');
          }
        });

        if (toggle && options.length) {
          var opt = options.find(function (o) {
            return o.getAttribute('data-value') === target;
          });
          if (opt) {
            setToggleLabel(toggle, opt.textContent || opt.innerText);
          }
        }
        options.forEach(function (opt) {
          var sel = opt.getAttribute('data-value') === target;
          opt.classList.toggle('is-active', sel);
          opt.setAttribute('aria-selected', sel ? 'true' : 'false');
        });
      }

      (function init() {
        var activeTab =
          tabs.find(function (t) {
            return t.classList.contains('is-active');
          }) || tabs[0];
        if (activeTab) {
          updatePanelState(activeTab.getAttribute('data-tab'));
        } else if (tabs[0]) {
          updatePanelState(tabs[0].getAttribute('data-tab'));
        }
      })();

      tabs.forEach(function (tab, idx) {
        tab.addEventListener('click', function (e) {
          e.preventDefault();
          updatePanelState(tab.getAttribute('data-tab'));
        });

        tab.addEventListener('keydown', function (e) {
          var key = e.key || e.keyCode;
          if (key === 'ArrowLeft' || key === 'Left' || key === 37) {
            e.preventDefault();
            var prev = tabs[(idx - 1 + tabs.length) % tabs.length];
            prev && prev.focus();
          } else if (key === 'ArrowRight' || key === 'Right' || key === 39) {
            e.preventDefault();
            var next = tabs[(idx + 1) % tabs.length];
            next && next.focus();
          } else if (key === 'Enter' || key === ' ' || key === 13 || key === 32) {
            e.preventDefault();
            updatePanelState(tab.getAttribute('data-tab'));
          }
        });
      });

      if (!dropdown || !toggle || !selectList || !options.length) return;

      function openDropdown() {
        dropdown.classList.add('open');
        toggle.setAttribute('aria-expanded', 'true');
        selectList.setAttribute('aria-hidden', 'false');
      }
      function closeDropdown() {
        dropdown.classList.remove('open');
        toggle.setAttribute('aria-expanded', 'false');
        selectList.setAttribute('aria-hidden', 'true');
      }

      toggle.addEventListener('click', function (e) {
        var isOpen = dropdown.classList.contains('open');
        if (isOpen) {
          closeDropdown();
        } else {
          openDropdown();
          var active =
            selectList.querySelector('.ps-dropdown-option.is-active') ||
            selectList.querySelector('.ps-dropdown-option');
          active && active.focus();
        }
      });

      options.forEach(function (opt, idx) {
        opt.addEventListener('click', function (e) {
          var target = opt.getAttribute('data-value');
          updatePanelState(target);
          closeDropdown();
          try {
            toggle.focus();
          } catch (err) {}
        });

        opt.addEventListener('keydown', function (e) {
          var key = e.key || e.keyCode;
          if (key === 'ArrowDown' || key === 'Down' || key === 40) {
            e.preventDefault();
            var next = options[(idx + 1) % options.length];
            next && next.focus();
          } else if (key === 'ArrowUp' || key === 'Up' || key === 38) {
            e.preventDefault();
            var prev = options[(idx - 1 + options.length) % options.length];
            prev && prev.focus();
          } else if (key === 'Home') {
            e.preventDefault();
            options[0] && options[0].focus();
          } else if (key === 'End') {
            e.preventDefault();
            options[options.length - 1] && options[options.length - 1].focus();
          } else if (key === 'Enter' || key === ' ' || key === 13 || key === 32) {
            e.preventDefault();
            var target = opt.getAttribute('data-value');
            updatePanelState(target);
            closeDropdown();
            try {
              toggle.focus();
            } catch (err) {}
          } else if (key === 'Escape' || key === 'Esc' || key === 27) {
            e.preventDefault();
            closeDropdown();
            try {
              toggle.focus();
            } catch (err) {}
          }
        });
      });

      document.addEventListener('click', function (e) {
        if (!dropdown.contains(e.target) && dropdown.classList.contains('open')) {
          closeDropdown();
        }
      });

      document.addEventListener('keydown', function (e) {
        if ((e.key === 'Escape' || e.keyCode === 27) && dropdown.classList.contains('open')) {
          closeDropdown();
        }
      });
    });
  })();